import React from 'react';
import { Link } from 'react-router-dom';

/**
 * HERO — built for a phone first.
 *
 * One thing, one ask. The client experience layer is a real second service but
 * it is deliberately absent from this page: it split the message and almost
 * nobody arrives wanting it. It lives at /client-experience, in the navigation
 * and in the footer, for the few who do.
 */
export default function HeroPremium() {
  return (
    <section className="relative isolate overflow-hidden bg-[#0A1A2F] text-[#F5F3EF]">
      <picture>
        <source srcSet="/generated/range-yacht-real.webp" type="image/webp" />
        <img
          src="/generated/range-yacht-real.jpg"
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
          style={{ objectPosition: '62% center' }}
          decoding="async"
          width="1122"
          height="1402"
        />
      </picture>
      {/* darker on small screens, where the text sits directly over the image */}
      <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(10,26,47,0.96),rgba(10,26,47,0.9))] lg:bg-[linear-gradient(100deg,rgba(10,26,47,0.98)_0%,rgba(10,26,47,0.92)_46%,rgba(10,26,47,0.5)_100%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(75%_55%_at_78%_45%,rgba(212,175,55,0.16),transparent_72%)]" />
      <div className="al-grain absolute inset-0 opacity-[0.055]" aria-hidden />

      <div className="relative mx-auto flex max-w-[1440px] flex-col justify-center px-5 pb-16 pt-28 sm:px-8 sm:pb-20 sm:pt-32 lg:min-h-[100svh] lg:px-16 lg:pb-24 lg:pt-28">
        <div className="max-w-[54ch]">
          <div className="al-eyebrow text-[#D4AF37]">
            <span aria-hidden />
            Design and build studio
          </div>

          <h1 className="mt-7 font-serif text-[clamp(2.9rem,10.5vw,5.6rem)] leading-[0.95] tracking-[-0.035em] sm:mt-8">
            We redesign <em className="font-normal text-[#D4AF37]">your website.</em>
          </h1>

          <p className="mt-7 max-w-[42ch] text-[17px] leading-[1.6] text-[#F5F3EF]/[0.82] sm:text-[clamp(1.05rem,1.7vw,1.32rem)]">
            Send us the address. We send back a redesign of it, built and live, before there is
            anything to commit to.
          </p>

          <div className="mt-10 flex flex-col items-start gap-4 sm:mt-12">
            <Link to="/contact" className="al-button al-button-light w-full justify-center sm:w-auto">
              Send us your site <span aria-hidden>→</span>
            </Link>
            <p className="text-[13px] leading-relaxed text-[#F5F3EF]/[0.55]">
              Takes a minute. Nothing to prepare.
            </p>
          </div>
        </div>

      </div>

      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/45 to-transparent" />
    </section>
  );
}
